<script>
  import { getTheme } from "../utilities/themes";
  import { validatePropValue } from "../utilities/logs";

  /** Primarily used for testing
   * @type {string}
   * */
  export let id = undefined;

  /** @type { string } */
  let className = "";
  export { className as class };

  /**
   * The type which determines the thickness of the rule.
   * @type {'thick' | 'thin'}
   */
  export let type = "thin";

  validatePropValue({
    componentName: "Rule",
    propName: "type",
    propValue: type,
    validPropValues: ["thin", "thick"]
  });

  /**
   * The theme of the component using the Rule.
   * @type {import('../utilities/themes').ThemeName}
   */
  export let theme = "white";

  $: themeClass = getTheme(theme)?.ruleColor || "bg-black";
</script>

{#if type === "thick"}
  <span {id} class="block {themeClass} h-[8px] md:h-[10px] lg:h-[12px] {className}" />
{:else if type === "thin"}
  <span {id} class="block {themeClass} h-[1px] {className}" />
{/if}
